import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../routes';
import TransportCompanyLogo from '../shared/TransportCompanyLogo';
import { TRANSPORT_COMPANY_LOGO_FORMATS } from '../../constants/transportCompanyLogo';
import { MenuIcon } from './icons';
import {
    HeaderContainer,
    HeaderLeft,
    MenuToggleButton,
    TenantLogo,
    UserProfile,
} from './styles';

export default function Header({ showMenuButton = false, onMenuClick }) {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <HeaderContainer>
            <HeaderLeft>
                {showMenuButton && (
                    <MenuToggleButton
                        type="button"
                        aria-label="Abrir menu"
                        onClick={onMenuClick}
                    >
                        <MenuIcon />
                    </MenuToggleButton>
                )}
                <TenantLogo>
                    <TransportCompanyLogo
                        format={TRANSPORT_COMPANY_LOGO_FORMATS.SVG}
                        fallback="Logo"
                    />
                </TenantLogo>
            </HeaderLeft>
            <UserProfile
                type="button"
                title="Perfil do usuário"
                onClick={() => navigate(ROUTES.PERFIL)}
            >
                <span>{user?.name || 'Perfil do usuário'}</span>
            </UserProfile>
        </HeaderContainer>
    );
}
